// Routes owned by the Contract module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const contractPaths = {
    createContract: '/contracts/new',
    contractDetail: '/contracts/:id',
    customerContractList: '/contracts',
    partnerContractList: '/contracts/partners',
    sampleContractList: '/contracts/samples',
    customerContractDetail: '/contracts/:id',
    subContractDetail: '/contracts/:contractID/subcontracts/:subcontractID',
    customerContractOverview: '/contracts/overview/:type',
    // Unreferenced: no paths.* caller; route is live (/contracts/partners/:id).
    partnerContractDetail: '/contracts/partners/:id',
    supplierDetail: '/contracts/partners/suppliers/:id',
    // Contract Negotiation
    contractNegotiation: '/contracts/negotiations',
    contractNegotiationDetail: '/contracts/negotiations/:id',
} as const
